import styled from 'styled-components';

import { Button, media } from '@minerva-analytics/pantheon';

import { MEDIUM_GRAY, LABEL } from 'root/theme';
import { SINGLE_COLUMN_BREAKPOINT } from 'utils';

const SubCategoryColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 3rem;
  max-width: 400px;
  width: 100%;
  margin-top: .5rem;

  @media (max-width: ${SINGLE_COLUMN_BREAKPOINT}px) {
    width: 100%;
    max-width: 100%;
    margin: 0px;
  }
`;

const QuizKindHeader = styled.div`
  display: flex;
  justify-content: ${(props) => props.kind === `S` ? `flex-end` : `space-around`};
  width: 10rem;
  margin-bottom: 5px;
  margin-right: -1.20rem;
`;

const QuizKind = styled.div`
  color: ${MEDIUM_GRAY};
  ${LABEL}
  padding: 0 0.25rem;
`;

const LoadButton = styled(Button)`
  display: none;
  ${media.medium`
    display: block;
    width: 100%;
  `}
`;

export {
  SubCategoryColumnContainer,
  QuizKindHeader,
  QuizKind,
  LoadButton,
};
